var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.446809 7.38516H4.61702V22H0.446809V7.38516ZM2.45745 0C3.87234 0 4.98936 1.16608 4.98936 2.64311C4.98936 4.12014 3.87234 5.28622 2.45745 5.28622C1.04255 5.28622 0 4.12014 0 2.64311C0 1.16608 1.11702 0 2.45745 0ZM7.07447 7.38516H11.1702V9.40636C12.0638 8.08481 13.4787 7.22968 15.117 7.22968H16.234C18.8404 7.22968 21 9.4841 21 12.2049V14.3816V17.0247V22H16.9043V21.9223V20.6007V14.0707C16.8298 12.4382 15.7872 11.1166 14.1489 11.1166C12.5851 11.1166 11.2447 12.4382 11.1702 14.0707V19.7456V21.9223H7.07447V7.38516Z",
    fill: "#F39422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.f3cdce06245feffb592cf5bc3066382e.svg";
export { ForwardRef as ReactComponent };